import {ProjectService} from "@/core/Services";

const getUrl = (data, type = null) => {
    const blob = new Blob([data], {type});
    return window.URL.createObjectURL(blob);
}

const downloadFile = (data, filename) => {
    let link = document.createElement('a');
    link.href = getUrl(data);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove()
}

const printFile = (data, type, windowReference) => {
    windowReference.location = getUrl(data, type)
    windowReference.focus()

    setTimeout(function () {
        windowReference.print()
    }, 500)
}

const getPdfByProjectUser = (userId, ProjectId, download = false, filename=null) => {
    let windowReference = null
    if (!download) {
        windowReference = window.open("about:blank", "_blank")
    }

    ProjectService.getProjectPdf(userId, ProjectId).then(response => {
        if (windowReference) {
            printFile(response, 'application/pdf', windowReference)
        } else {
            downloadFile(response, filename)
        }
    }).catch(error => {
        console.error("Error downloading PDF", error);
    })
}

const getPdfByUserGuest = (project, projectImages, download = false, filename=null) => {
    let windowReference = null
    if (!download) {
        windowReference = window.open("about:blank", "_blank")
    }

    const payload = { ...project, projectImages }

    ProjectService.getProjectPdfByUserGuest(payload).then(response => {
        if (windowReference) {
            printFile(response, 'application/pdf', windowReference)
        } else {
            downloadFile(response, filename)
        }
    }).catch(error => {
        console.error("Error downloading PDF", error);
    })
}

export default {
    downloadFile,
    printFile,
    getPdfByProjectUser,
    getPdfByUserGuest
}
